export const faqExists = () => {
  return false;
};

export const openFaq = () => window.AnswerDash.base.open();
